<template>
  <section>
    <navbar />
    <div>
      <router-view />
    </div>
  </section>
</template>

<script>
import Navbar from "../parts/Navbar";

export default {
  components: { Navbar },
  name: "User",
  data() {
    return {};
  },
  created() {
    let currentUser = null;
    if (this.$store.state.auth.user !== undefined) {
      currentUser = this.$store.state.auth.user;

      // Only redirect if we're at the root path, not when navigating to a specific child route
      if (this.$route.path === "/") {
        if (currentUser.role === "Admin") {
          this.$router.push("/admin");
        } else {
          this.$router.push("/user");
        }
      }
    }
  },
};
</script>

